import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CxAdvFiltersService } from '../cx-adv-filters.service';
import { CxAdvFiltersDataService } from '../cx-adv-filters-data.service';
import { Field } from '../cx-adv-filters.types';
import { OptionsLabelMapped } from '../cx-constants';
import moment from 'moment';

@Component({
  selector: 'app-cx-adv-filters-list',
  templateUrl: './cx-adv-filters-list.component.html',
  styleUrl: './cx-adv-filters-list.component.scss'
})
export class CxAdvFiltersListComponent implements OnInit {
  @Output() echange = new EventEmitter();
  @Output() apply = new EventEmitter();
  @Output() create = new EventEmitter();
  @Output() updateview = new EventEmitter();
  @Output() temp = new EventEmitter();

  @ViewChild('content', { static: false }) content!: ElementRef;
  viewNameError = false;
  nameEdit = false;
  tempName = '';

  constructor (
    public cadvFilters: CxAdvFiltersService, 
    public cadvDataFilters: CxAdvFiltersDataService
  ) {}
  
  ngOnInit(): void {
    this.tempName = this.cadvFilters.currentView.name;
  }

  addGroupAndField (e: MouseEvent) {
    this.cadvFilters.empty();
    this.cadvFilters.currentGroupIndex = 0;
    this.cadvFilters.currentScreen = this.cadvFilters.SCREENS.ONE;
  }

  addField (e: MouseEvent, groupIndex: number) {
    this.cadvFilters.currentGroupIndex = groupIndex;
    this.cadvFilters.emptyGroup(groupIndex);
    this.cadvFilters.currentScreen = this.cadvFilters.SCREENS.ONE;
  }

  addFilter (e: MouseEvent, groupIndex: number) {
    this.cadvFilters.currentGroupIndex = groupIndex;
    this.cadvFilters.currentScreen = this.cadvFilters.SCREENS.ONE;
  }

  editFilter (e: MouseEvent, filter: Field, groupIndex: number, filterIndex: number) {
    this.cadvFilters.currentGroupIndex = groupIndex;
    this.cadvFilters.currentFilterIndex = filterIndex;
    
    if (filter.type === 'datetime') {
      filter.options = filter.options?.map((x) => {
        if (filter.operatorName === x.value) {
          x.field_options = x.field_options.map((opt: any) => {
            if ((opt.type === 'date' || opt.type === 'datetime') && opt.selected) {
              opt.selected = moment.utc(opt.selected, "YYYY-MM-DD hh:mm:ss a.").toDate();
            }
            return opt;
          })
        }
        return x;
      })
    }

    this.cadvFilters.currentField = filter;
    this.cadvFilters.currentScreen = this.cadvFilters.SCREENS.TWO;
  }

  addGroup (e: MouseEvent) {
    const index = this.cadvFilters.addGroup() - 1;
    this.addFilter(e, index);
  }

  onCreateView(e: MouseEvent) {
    if (!this.cadvFilters.currentView.name || this.cadvFilters.currentView.name.length > 60) {
      this.viewNameError = true;
      return;
    } else {
      this.viewNameError = false;
    }

    this.create.next(this.cadvFilters.filters);
  }

  printSelectedValues (filter: Field) {
    const option = filter.options?.find((x) => x.value === filter.operatorName);

    if (option.value === 'in' || option.value === 'not-in' || option.value === 'contain' || option.value === 'not-contain') {
      return option?.field_options?.find(Boolean)?.selected_list?.join(', ') || '';
    } else if (option.value === 'is-between') {
      if (filter.type == 'datetime') {
        return option?.field_options?.map((x: any) => moment.utc(x.selected, "YYYY-MM-DD hh:mm:ss a.").add(1, 'day').format('DD/MM/YYYY'))?.join(' and ') || '';
      }
      return option?.field_options?.map((x: any) => x.selected)?.join(' and ') || '';
    } else if (option.value === 'is-less-than' || option.value === 'is-more-than') {
      return option?.field_options?.map((x: any) => (OptionsLabelMapped[x.selected] || x.selected))?.join(' ') || '';
    } else if (option.value === 'is' || option.value === 'is-equal' || option.value === 'is-not') {
      if (filter.type === 'datetime' &&  option.value === 'is-equal') {
        return  moment.utc(option?.field_options?.find(Boolean)?.selected || '', "YYYY-MM-DD hh:mm:ss a.").add(1, 'day').format('YYYY-MM-DD');
      }
      if (filter.type === 'datetime' &&  option.value === 'is') {
        const soptions = filter.options?.find((x) => x.value === option.value);
        const first = soptions.field_options.find(Boolean);
        if (first) {
          const selected = first.values.find((x: any) => x.value === first.selected);
          if (selected) {
            return selected.label;            
          }
        }
        return '...';
      }
      const fopt = option?.field_options?.find(Boolean);
      if (fopt?.type === 'input') {
        return fopt.selected ?? '';
      }
      return fopt?.values?.find((x: any) => x.value === fopt.selected)?.label || fopt?.selected || '...';
    }

    return option?.field_options?.find(Boolean)?.selected || '';
  }

  removeGroup (e: MouseEvent, groupIndex: number) {
    e.preventDefault();
    e.stopPropagation();
    
    this.cadvFilters.softRemoveGroup(groupIndex);

    this.echange.emit('change');
  }

  removeField (e: MouseEvent, fieldIndex: number, groupIndex: number, filter: Field) {
    e.preventDefault();
    e.stopPropagation();
    
    this.cadvFilters.softRemoveFilter(fieldIndex, groupIndex);

    this.echange.emit('change');
  }

  revert (e: MouseEvent) {
    this.cadvFilters.revertRemovedFilters();
    this.echange.emit('change');
    this.temp.emit('');
  }

  saveFilters (e: MouseEvent) {
    e.preventDefault();
    if (this.cadvFilters.filters.filter((x: any) => !x.deleted).length === 0) {
      this.addGroupAndField(e);
    }
    this.cadvFilters.removeDeletedGroupAndFilters();
    this.temp.emit('');
    this.apply.emit('apply');
  }

  onClose ($event: any) {
    this.onNameSave($event, () => {
      this.cadvFilters.close();
    });

    if (this.cadvFilters.currentView.name === this.tempName) {
      this.cadvFilters.close();
    }
  }

  onNameChange ($event: string) {
    if (!this.cadvFilters.currentView.name || this.cadvFilters.currentView.name.length > 60) {
      this.viewNameError = true;
    } else {
      this.viewNameError = false;
    }
  }

  getGroupIndex (groupId: String) {
    const index = this.cadvFilters.filters.filter((x) => !x.deleted).findIndex((x) => x.gid == groupId);
    return index + 1;
  }

  onNameSave ($event: FocusEvent | MouseEvent, callback: Function | null) {
    $event.preventDefault();
    $event.stopPropagation();
    $event.stopImmediatePropagation();

    if (!this.cadvFilters.currentView.name || this.cadvFilters.currentView.name.length > 60) {
      this.viewNameError = true;
      return;
    } else {
      this.viewNameError = false;
    }

    if (this.cadvFilters.currentView.id) {
      this.cadvFilters.updateViewName({ id: this.cadvFilters.currentView.id, name: this.cadvFilters.currentView.name }).subscribe((x) => {
        this.nameEdit = false;
        this.updateview.emit('');
        this.tempName = this.cadvFilters.currentView.name;
        if (typeof callback == 'function') {
          callback();
        }
      })
    }
  }
}

